import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=1d5f986e&scoped=true"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"
import style0 from "./Secure.vue?vue&type=style&index=0&id=1d5f986e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f986e",
  null
  
)

export default component.exports